var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.18918,
    fill: "#0096FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5002V9.46245C4 9.36488 4.10268 9.30142 4.18995 9.34506L9.8262 12.1632C10.5652 12.5327 11.4351 12.5327 12.1741 12.1632L17.8104 9.34506C17.8976 9.30142 18.0003 9.36488 18.0003 9.46245V14.5002C18.0003 15.4667 17.2168 16.2502 16.2503 16.2502H5.75004C4.78352 16.2502 4 15.4667 4 14.5002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.49965V8.29355C4 8.34327 4.02809 8.38872 4.07255 8.41095L9.8262 11.2878C10.5652 11.6573 11.4351 11.6573 12.1741 11.2878L17.9278 8.41095C17.9722 8.38872 18.0003 8.34327 18.0003 8.29355V7.49965C18.0003 6.53313 17.2168 5.74961 16.2503 5.74961H5.75004C4.78352 5.74961 4 6.53313 4 7.49965Z",
    fill: "#FFC814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.467d9bebb1313418d30b933c05cfefc2.svg";
export { ForwardRef as ReactComponent };